import { Radio, Button, Tabs, Popconfirm, Form } from "antd";
import { useState } from "react";
import { DeleteOutlined } from "@ant-design/icons";
import { useStore } from "../../context/StoreContext";
import { Severty, ShowToast } from "../../helper/toast";
import UniversalModal from "../../components/UniversalModal";
import DeliveryAddressModal from "./DeliveryAddressModal";

const AddressSection = ({ savedInfo, setSavedInfo, address, fetchAddress }) => {
  const { deleteAddress } = useStore();
  const handleDeleteAddress = async (addressId) => {
    const response = await deleteAddress(addressId);
    if (response.status === 200) {
      fetchAddress();
      ShowToast(response.message, Severty.SUCCESS);
    }
  };
  // data how to like see after add
  // const addresses01 = [
  //   {
  //     label: "Markus Villa",
  //     value: 1,
  //     desc: "1020, 12, Silver tower, Al Nahda 2, DWC - Al Sarayat St - Jumeirah Lakes Towers, Cluster V - Kuwait ",
  //   },
  // ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [isOrderSuccessOpen, setIsOrderSuccessOpen] = useState(false);
  const [isErrorOpen, setIsErrorOpen] = useState(false);
  const [saveAddress, setSaveAddress] = useState(false);

  const handleRadioChange = (e) => {
    setSelectedValue(e.target.value);
    setIsOrderSuccessOpen(true);
  };

  const handleSavedAddressChange = (e) => {
    setSelectedValue(e.target.value);
  };
  const handleConfirmLocation = (value) => {
    if (value) {
      setIsOrderSuccessOpen(true);
      setSaveAddress(true);
      setSavedInfo({ ...savedInfo, addInfo: true });
    } else {
      ShowToast("Please select an address first", Severty.WARNING);
    }
  };

  return (
    <div className="games-tabs">
      <Tabs className="custom-tabs" defaultActiveKey="1">
        <Tabs.TabPane tab="Saved Addresses" key="1">
          {/* 🔹 Save addressId in form value */}
          <Form.Item
            name="addressId"
            rules={[{ required: true, message: "Please select an address" }]}
          >
            <Radio.Group
              className="address-radio-group"
              value={selectedValue}
              onChange={(e) => setSelectedValue(e.target.value)}
            >
              {address?.addresses?.map((addr) => (
                <Radio
                  className="checkout-address-main"
                  key={addr._id}
                  value={addr._id}
                >
                  <div className="checkout-address-main">
                    <div className="checkout-address">
                      <div className="address-label">{addr?.name}</div>
                      <div className="address-desc">{addr?.fullAddress}</div>
                      <div className="address-desc">{`${addr.countryCode} ${addr?.mobileNumber}`}</div>
                    </div>
                    <div className="checkout-address-delete">
                      <Popconfirm
                        title="Are you sure you want to delete this address?"
                        onConfirm={() => handleDeleteAddress(addr._id)}
                      >
                        <Button
                          type="text"
                          icon={<DeleteOutlined style={{ color: "orange" }} />}
                        />
                      </Popconfirm>
                    </div>
                  </div>
                </Radio>
              ))}
            </Radio.Group>
          </Form.Item>

          <Form.Item shouldUpdate noStyle>
            {({ setFieldsValue }) => (
              <Button
                className="Fill-button"
                onClick={() => {
                  if (selectedValue) {
                    setFieldsValue({ addressId: selectedValue });
                    handleConfirmLocation(selectedValue);
                  } else {
                    setIsErrorOpen(true);
                  }
                }}
              >
                {saveAddress ? " Location Confirmed" : "Confirm Location"}
              </Button>
            )}
          </Form.Item>
        </Tabs.TabPane>

        <Tabs.TabPane tab="New Address" key="2">
          <div className="checkout-addres">
            <Button
              className="Fill-button"
              onClick={() => setIsModalOpen(true)}
            >
              Add Address
            </Button>

            {/* <Form.Item name="addressId">
              <Radio.Group className="address-radio-group">
                {addresses01.map((addr) => (
                  <Radio
                    className="checkout-address-main"
                    key={addr.value}
                    value={addr.value}
                  >
                    <div className="checkout-address">
                      <div className="address-label">{addr.label}</div>
                      <div className="address-desc">{addr.desc}</div>
                    </div>
                  </Radio>
                ))}
              </Radio.Group>
            </Form.Item> */}
          </div>
        </Tabs.TabPane>
      </Tabs>

      {/* Delivery address modal */}
      <DeliveryAddressModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />

      {/* confirm modal */}
      <UniversalModal
        open={isOrderSuccessOpen}
        onClose={() => setIsOrderSuccessOpen(false)}
        title="Address Confirmation"
        message="Saved address successfully"
        footerButtonLabel="Back to Address"
      />

      {/* Error modal */}
      <UniversalModal
        open={isErrorOpen}
        onClose={() => setIsErrorOpen(false)}
        title="Address Required"
        message="Please select an address first"
        footerButtonLabel="Back"
      />
    </div>
  );
};

export default AddressSection;
